import Vue from 'vue'
import { fb } from '../plugins/firebase'
import { momento } from '../plugins/moment'
import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    deVenta: false,
    catalogo: [],
    indices: [],
    indicesFiltrados: [],
    indicesDestacados: [],
    destacados: [],
    seleccionado: {},
    googleados: [],
    letra: 'a',
    cargando: false,
    modo: 'web',
    filtros: {
      titulo: '',
      autor: '',
      coleccion: '',
      editorial: '',
      nuevo: true,
      usado: true
    },
    vista: '',
    singleData: 'DataWEB',
    promocion: false
  },
  mutations: {
    promocion: (state, p) => state.promocion = p,
    vista (state, p) {
      state.vista = p
    },
    singleData (state, p) {
      state.singleData = p
    },
    googleados (state, p) {
      state.googleados = p
    },
    pushNuevo (state, p) {
      state.catalogo.push(p)
    },
    setCatalogo (state, p) {
      state.catalogo = p
    },
    setLetra (state, p) {
      state.letra = p
    },
    cargando (state, p) {
      state.cargando = p
    },
    seleccionado (state, p) {
      state.seleccionado = p
    },
    indices (state, p) {
      state.indices = p
    },
    indicesFiltrados (state, p) {
      state.indicesFiltrados = p
    },
    modo (state, p) {
      state.modo = p
    },
    setFiltros (state, p) {
      state.filtros = p
    },
    deVenta (state, p) {
      state.deVenta = p
    },
    updateIndice (state, p) {
      let index = state.indices.findIndex(sel => sel.id === p.id)
      if (index !== -1)
        state.indices[index] = p
      else 
        state.indices.push(p)
    },
    indicesDestacados (state, p) {
      state.indicesDestacados = p
    },
    setDestacados (state, p) {
      state.destacados = p
    },
    modIndiceDestacado (state, p) {
      if (p.accion === 'agregar')
        state.indicesDestacados.push(p.id)
      else if (p.accion === 'remover') {
        let index = state.indicesDestacados.findIndex(sel => sel === p.id)
        state.indicesDestacados.splice(index, 1)
      }
    },
    destacarIndice (state, p) {
      console.log(state.indices, p)
      let sel = state.indices.find(se => se.id === p.id)
      sel.destacado = p.estado
    }
  },
  actions: {
    googlear (ctx, p) {
      return new Promise ((resolve, reject) => {
        let base = ''
        let goo = ''
        if (p.tipo === 'titulo') {
          goo = p.text.trim().toLowerCase().replace(/ /g,"+")
          base = 'https://www.googleapis.com/books/v1/volumes?q=' + goo + '&maxResults=40'
        } else if (p.tipo === 'isbn') {
          goo = p.text.trim()
          base = 'https://www.googleapis.com/books/v1/volumes?q=isbn:' + goo
        }
        Vue.prototype.$axios.get(base)
        .then(ans => {
          let todos = ans.data.items.map(item => {
            let sel = {
              portada: '',
              titulo: item.volumeInfo.title || '',
              isbn10: '',
              isbn13: '',
              autor: item.volumeInfo.authors ? item.volumeInfo.authors.join(', ') : '',
              editorial: item.volumeInfo.publisher || '',
              paginas: item.volumeInfo.pageCount || 0,
              anio: item.volumeInfo.publishedDate || 0,
              idioma: item.volumeInfo.language || 'es',
              descripcion: item.searchInfo ? item.searchInfo.textSnippet : 'Sin Resumen'
            }
            if (item.volumeInfo.imageLinks) {
              sel.portada = item.volumeInfo.imageLinks.thumbnail ? item.volumeInfo.imageLinks.thumbnail : ''
            }
            if (item.volumeInfo.industryIdentifiers) {
              let isbn10 = item.volumeInfo.industryIdentifiers.find(se => se.type === 'ISBN_10')
              let isbn13 = item.volumeInfo.industryIdentifiers.find(se => se.type === 'ISBN_13')
              sel.isbn10 = isbn10 !== undefined ? isbn10.identifier : ''
              sel.isbn13 = isbn13 !== undefined ? isbn13.identifier : ''
            }
            return sel
          })
          ctx.commit('googleados', todos)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    addIndice (ctx, p) {
      return new Promise ((resolve, reject) => {
        let unido = p.autor.split(' ').concat(p.titulo.split(' '))
        let unido2 = p.coleccion.split(' ').concat(p.editorial.split(' '))
        let indice = {
          busqueda1: [],
          busqueda2: [],
          nuevo: p.nuevo,
          usado: p.usado,
          destacado: p.destacado,
          modo: p.disponibilidad === 'Web' ? 'web' : 'app'
        }
        unido.forEach(item => {
          if (item.length > 3)
            indice.busqueda1.push(limpiar(item))
        })
        unido2.forEach(item => {
          if (item.length > 3)
            indice.busqueda2.push(limpiar(item))
        })
        indice.busqueda1 = indice.busqueda1.join('')
        indice.busqueda2 = indice.busqueda2.join('')

        fb.collection('indice').doc(p.id).set(indice)
        .then(() => {
          ctx.commit('updateIndice', p)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    add (ctx, p) {
      return new Promise ((resolve, reject) => {
        p.creado = momento().format()
        p.inicial = p.inicial.toLowerCase()
        fb.collection('libros').add(p).then(ans => {
          p.id = ans.id
          if (p.inicial === ctx.state.letra)
            ctx.commit('pushNuevo', p)
          return ctx.dispatch('addIndice', p)
        })
        .then(() => {
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    buscarLetra (ctx) {
      return new Promise ((resolve, reject) => {
        ctx.commit('cargando', true)
        let p = ctx.state.letra
        fb.collection('libros').where("inicial", "==", p.toLowerCase()).get()
        .then(results => {
          let all = []
          results.forEach(doc => {
            let libro = doc.data()
            libro.id = doc.id
            if (ctx.state.modo === 'web' && libro.disponibilidad === 'Web')
              all.push(libro)
            else if (ctx.state.modo === 'app')
              all.push(libro)
          })
          ctx.commit('setCatalogo', all)
          ctx.commit('cargando', false)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    destacar (ctx, p) {
      return new Promise ((resolve, reject) => {
        let carga = {destacado: p.estado}
        if (p.estado)
          carga.destacadoEl = momento().format()
        else
          carga.unDestacadoEl = momento().format()
        fb.collection('libros').doc(p.id).update(carga)
        .then(() => {
          ctx.state.seleccionado.destacado = p.estado
          // enviar a indices destacados
          let accion = p.estado ? 'agregar' : 'remover'
          ctx.commit('modIndiceDestacado', {accion: accion, id: p.id})
          ctx.commit('destacarIndice', {estado: p.estado, id: p.id})
          return fb.collection('indice').doc(p.id).update({destacado: p.estado})
        })
        .then(() => {
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    armarIndices (ctx) {
      return new Promise ((resolve, reject) => {
        let all = []
        fb.collection('indice').get()
        .then(results => {
          results.forEach(doc => {
            let item = doc.data()
            item.id = doc.id
            all.push(item)
          })
          ctx.commit('indices', all)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    filtrarIndices (ctx) {
      return new Promise ((resolve) => {
        let sels = []
        let filtros = ctx.state.filtros
        ctx.state.indices.forEach(item => {
          let enviar = false

          if (filtros.titulo !== '' && filtros.titulo !== undefined) {
            separar(filtros.titulo).forEach(filtro => {
              if (item.busqueda1.includes(filtro)) {
                enviar = true
              }
            })
          }
          if (filtros.autor !== '' && filtros.autor !== undefined) {
            separar(filtros.autor).forEach(filtro => {
              if (item.busqueda1.includes(filtro))
                enviar = true
            })
          }
          // if (filtros.editorial !== '' && filtros.editorial !== undefined) {
          //   separar(filtros.editorial).forEach(filtro => {
          //     if (item.busqueda2.includes(filtro))
          //       enviar = true
          //   })
          // }
          if (filtros.coleccion !== '' && filtros.coleccion !== undefined) {
            separar(filtros.coleccion).forEach(filtro => {
              if (item.busqueda2.includes(filtro))
                enviar = true
            })
          }

          if (enviar) {

            if (item.nuevo === filtros.nuevo)
              enviar = true
            else 
              enviar = false
            
            if (item.usado === filtros.usado)
              enviar = true
            else 
              enviar = false

            if (filtros.nuevo && filtros.usado)
              enviar = true
          }
          if (enviar) {
            if (ctx.state.modo === 'web' && item.modo === 'web')
              sels.push(item.id)
            else if (ctx.state.modo === 'app')
              sels.push(item.id)
          }
        })
        ctx.commit('indicesFiltrados', sels)
        resolve()
      })
    },
    realizarFiltro (ctx) {
      return new Promise ((resolve, reject) => {
        ctx.dispatch('armarIndices')
        .then(() => {
          return ctx.dispatch('filtrarIndices')
        })
        .then(() => {
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    filtrarDestacados (ctx) {
      return new Promise((resolve) => {
        let sels = []
        ctx.state.indices.forEach(item => {
          if (item.destacado && item.modo === 'web')
            sels.push(item.id)
          ctx.commit('indicesDestacados', sels)
          resolve()
        })
      })
    },
    destacados (ctx) {
      return new Promise((resolve, reject) => {
        ctx.dispatch('armarIndices')
        .then(() => {
          ctx.dispatch('filtrarDestacados')
        })
        .then(() => {
          let promesas = []
          ctx.state.indicesDestacados.forEach(item => {
            let p = fb.collection('libros').doc(item).get()
            promesas.push(p)
          })
          return Promise.all(promesas)
        })
        .then(solved => {
          let finales = []
          solved.forEach(item => {
            let book = item.data()
            book.id = item.id
            finales.push(book)
          })
          ctx.commit('setDestacados', finales)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    mostrarFiltrados (ctx) {
      return new Promise ((resolve, reject) => {
        let promesas = []
        let all = []
        ctx.commit('setCatalogo', [])
        ctx.state.indicesFiltrados.forEach(item => {
          let p = fb.collection('libros').doc(item).get()
          promesas.push(p)
        })
        Promise.all(promesas)
        .then(ans => {
          if (ans.length === 0)
            all = []
          else {
            ans.forEach(pro => {
              if (pro.exists) {
                let sel = pro.data()
                sel.id = pro.id
                all.push(sel)
              }
            })
          }
          ctx.commit('setCatalogo', all)
          ctx.commit('cargando', false)
          resolve()
        })
        .catch(e => {
          console.error(e)
          ctx.commit('cargando', false)
          reject()
        })
      })
    },
    guardarEdicion (ctx, p) {
      return new Promise ((resolve, reject) => {
        ctx.dispatch('addIndice', p)
        .then(() => {
          return fb.collection('libros').doc(p.id).update(p)
        })
        .then(() => {
          return ctx.dispatch('addIndice', p)
        })
        .then(() => {
          ctx.state.seleccionado = p
          resolve()
        })
        .catch(e => {
          console.error(e)
          ctx.commit('cargando', false)
          reject()
        })
      })
    }
  },
  getters: {
    googleados: (state) => state.googleados,
    getAll (state) {
      return state.catalogo.sort((a, b) => {
        const aL = limpiar(a.titulo)
        const bL = limpiar(b.titulo)
        if (aL < bL)
          return -1 
        if (aL > bL)
          return 1
        return 0
      })
    },
    getLetra: (state) => state.letra,
    cargando: (state) => state.cargando,
    seleccionado: (state) => state.seleccionado,
    deVenta: (state) => state.deVenta,
    destacados (state) {
      return state.destacados.sort((a, b) => {
        const aL = limpiar(a.titulo)
        const bL = limpiar(b.titulo)
        if (aL < bL)
          return -1 
        if (aL > bL)
          return 1
        return 0
      })
    },
    indices: (state) => state.indices,
    vista: (state) => state.vista,
    singleData: (state) => state.singleData,
    promocion: (state) => state.promocion
  }
}

function separar(s) {
  let r = []
  s.split(' ').forEach(item => {
    if (item.length > 3)
      r.push(limpiar(item))
  })
  return r
}